import React, {Component} from "react";
import {LockOutlined, UserOutlined} from '@ant-design/icons';
import {Form} from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import {Alert, Button, Checkbox, Col, Divider, Input, message, Row, Tooltip} from "antd";
import {connect} from "react-redux";
import {login, saveDeploymentModeInCookie} from "../redux_actions/login.action";
import {Link} from "react-router-dom";
import {checkCapsLockOn, checkIfMobile, isTrue} from '../utils/utils'
import {componentIds, MorphleLogo} from '../utils/const'
import '../asset/style/login.css'
import TawkBot from "../component/gammaviewer/components/tawkBot";
import cookie from "react-cookies";
import {Redirect} from "react-router-dom/cjs/react-router-dom.min";

class NormalLoginForm extends Component {
	constructor(props) {
		super(props);
		this.formRef = React.createRef();
		this.state = {
			isFetching: false,
			capsLockOn: false
		};
	}

	watchKeyBoard = (e) => {
		this.setState({capsLockOn: checkCapsLockOn(e, this.state.capsLockOn)})
	}
	
	componentDidMount = () => {
		let isMobile = checkIfMobile();
		document.documentElement.style.setProperty('--login-div-size', isMobile ? "20em" : "40em");
		saveDeploymentModeInCookie();
		document.addEventListener('keyup', this.watchKeyBoard)

		if(localStorage.getItem("showLogoutMessage")){
			message.warning("You have been logged out due to inactivity", 10);
			localStorage.removeItem("showLogoutMessage")
		}
	}

	componentWillUnmount = () => {
		document.removeEventListener('keyup', this.watchKeyBoard)
	}

	handleSubmit = e => {
		e?.preventDefault();
		this.props.form.validateFields((err, values) => {
			if (!err) {
				this.props.dispatch(login(values));
			}
		});
	};

	getPasswordPrefix = () => {
		if (this.state.capsLockOn) {
			return <Tooltip title="CapsLock is ON"><LockOutlined style={{color: "rgba(255, 191, 0, 1)"}}/></Tooltip>
		}
		return <LockOutlined style={{color: "rgba(0,0,0,.25)"}}/>
	}

	renderForm() {
		const {getFieldDecorator} = this.props.form;

		let content = [];
		content = content.concat([
			<Form.Item>
				{getFieldDecorator("username", {
					rules: [{required: true, message: "Please input your username!"}]
				})(
					<Input
						prefix={<UserOutlined style={{color: "rgba(0,0,0,.25)"}}/>}
						placeholder="Username"
					/>
				)}
			</Form.Item>,
			<Form.Item
				extra={this.state.capsLockOn ? <label style={{color: "rgba(255, 191, 0, 1)"}}>CapsLock is On</label> :
					<label style={{color: "rgba(0, 0, 0, 0)"}}>CapsLock is Off</label>}>
				{getFieldDecorator("password", {
					rules: [{required: true, message: "Please input your Password!"}]
				})(
					<Input.Password
						prefix={this.getPasswordPrefix()}
						placeholder="Password"
					/>
				)}
			</Form.Item>,
			<Form.Item style={{display: "none"}}>
				{
					getFieldDecorator("csrfmiddlewaretoken", {
						valuePropName: "Checked",
						initialValue: this.props.csrfToken
					})(<Checkbox/>)}
			</Form.Item>
		]);
		if (this.props.isServerUnreachable) {
			content.push(<div style={{color: "red"}}>Server is Unreachable. Please Contact Morphle Support.</div>);
		}
		if (this.props.isLockedOut) {
			content.push(<div style={{color: "red"}}>Too many failed login attempts. Please Contact Morphle
				Support.</div>);
		}
		if (this.props.isForbidden && !this.props.isLockedOut) {
			content.push(<div style={{color: "red"}}>Access denied. Please Contact Morphle Support.</div>);
		}
		if (this.props.isWrongCredential) {
			content.push(<div style={{color: "red"}}>{this.props.loginFailureMessage}</div>);
		}
		content.push(
			<Form.Item>
				{
					getFieldDecorator("remember", {
						valuePropName: "checked",
						initialValue: true
					})(<Checkbox>Remember me</Checkbox>)}
				<Button
					type="primary"
					htmlType="submit"
					className="login-form-button"
					loading={this.props.isFetching}>
					Enter
				</Button>
			</Form.Item>
		);

		return content;
	}
	removeMessageAndResolution = () => {
		cookie.remove("display_message", {path: "/"});
		cookie.remove("resolution", {path: "/"});
	}

	renderContent() {


		if (this.props.message && this.props.resolution) {
			return [
				<div className="logout-message">
					<Alert
						message={this.props.message + " " + this.props.resolution}
						type="error"/>
					<Divider style={{padding: "1px"}}/>
					<Button type="primary" style={{marginTop: "20px"}} onClick={() => this.removeMessageAndResolution()}><Link to="/login">Click here to
						login</Link></Button>
				</div>,
			];
		}
		let content = [];
		content.push(<p className="morphle-title unselectable"> Login to Morphle </p>);
		if (this.props.demoLogin) {
			let elems = [
				<p key={0} className="demo-login">For Accessing Demo Scans</p>,
				<p key={1} className="demo-login"><b>username</b> : morphledemo</p>,
				<p key={2} className="demo-login"><b>password</b> : demouser1234</p>
			];
			content = content.concat(elems);
		}

		content.push(
			<Form ref={this.formRef} onSubmit={this.handleSubmit}>
				{this.renderForm()}
			</Form>
		);

		return content;
	}

	render() {
		if(isTrue(this.props.isTotpEnabled)){
			return <Redirect to={"/totp/"}></Redirect>
		}

		let tawkBot = null;
		if (cookie.loadAll().deployment_mode === 'cloud') {
			tawkBot = <TawkBot/>;
		}

		return (
			<Row>
				<Col className="login-form overlayed-component">
					<Link to={'/'}><img className="login-logo" src={MorphleLogo} alt={"Morphle Logo"}/></Link>
					{this.renderContent()}
				</Col>
				<Col>
					<div id={componentIds.tawkIntegration}>
						{tawkBot}
					</div>
				</Col>
			</Row>
		);
	}
}

const WrappedNormalLoginForm = Form.create()(NormalLoginForm);

const mapStateToProps = state => {
	return state.loginAlerts;
};

export default connect(mapStateToProps)(WrappedNormalLoginForm);
